import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-mobile-numeric-search-input',
  templateUrl: './mobile-numeric-search-input.component.html',
  styleUrls: [
    './mobile-numeric-search-input.component.scss',
    '../odata-typeahead-search/odata-typeahead-search.component.scss'
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MobileNumericSearchInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileNumericSearchInputComponent implements ControlValueAccessor, OnChanges {
  @Input() placeholder: string = '';
  @Input() disabled: boolean = false;
  @Output() searchValueChanged: EventEmitter<string> = new EventEmitter<string>();
  @Input() controlId: string | null = null;

  @ViewChild('search') search!: ElementRef<HTMLInputElement>;

  constructor(private cdr: ChangeDetectorRef) {}

  public searchValue: string | number = '';

  private onChange: (value: number | null) => void = () => {};
  private onTouched: () => void = () => {};

  public searchChanged(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.searchValue = value;
    this.onChange(value ? Number(value) : null);
    this.onTouched();
    this.searchValueChanged.emit(value);
  }

  public clearSearch(input: HTMLInputElement) {
    this.searchValue = '';
    this.onChange(null);
    input.focus();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled) {
      if (!!this.search) {
        this.search.nativeElement.value = '';
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: number | null): void {
    this.searchValue = value ?? '';
    this.cdr.markForCheck();
  }
}
